import { siteConfig } from '@/mocks/data';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CatalogEntry() {
  const section = useScrollReveal();

  return (
    <section className="relative w-full min-h-[80svh] flex items-center px-6 md:px-10 py-24 md:py-32 bg-primary-950/80 overflow-hidden" ref={section.ref}>
      <div
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse 60% 50% at 50% 40%, oklch(var(--primary-950) / 0.2), transparent)',
        }}
      ></div>

      <div className="absolute top-0 left-0 right-0 h-px bg-background-50/6"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-background-50/6"></div>

      <div className="absolute top-6 right-6 md:top-10 md:right-14 select-none pointer-events-none">
        <span className="font-heading text-5xl md:text-7xl font-bold text-background-50/[0.025]">03</span>
      </div>

      <div className="absolute left-8 md:left-14 top-1/2 -translate-y-1/2 w-1 h-20 md:h-28 rounded-full bg-primary-500/20"></div>

      <div className={`relative z-10 w-full max-w-3xl mx-auto text-center transition-all duration-700 ease-out ${section.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="inline-flex items-center gap-3 mb-7">
          <span className="block w-5 h-px bg-primary-400/40"></span>
          <span className="text-[13px] text-primary-400/80 tracking-[0.15em] uppercase font-medium">書目資料庫</span>
          <span className="block w-5 h-px bg-primary-400/40"></span>
        </div>

        <h2 className="font-heading text-[2.25rem] md:text-[3rem] lg:text-[3.5rem] font-semibold text-background-50 mb-5 leading-[1.2] tracking-tight">
          查詢完整書目資訊
        </h2>

        <p className="text-base md:text-lg text-background-50/50 leading-relaxed max-w-lg mx-auto mb-11 font-light tracking-wide">
          如需確認完整書名、作者、ISBN、出版日期及其他正式出版資料，請前往崧博出版書籍資料庫查詢。
        </p>

        <a
          href={siteConfig.catalogUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="whitespace-nowrap inline-flex items-center gap-2.5 px-8 py-3.5 rounded-full text-[15px] font-medium bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer tracking-wide"
        >
          前往崧博出版書籍資料庫
          <i className="ri-external-link-line text-[13px]"></i>
        </a>
      </div>
    </section>
  );
}